<div class="h-100 overflow-auto crm-scroll">
  <div class="d-flex flex-row align-items-center justify-content-between px-4 py-3">
    <h4 class="m-0 text-crm">{{ 'invite_new_manager' | translate }}</h4>
    @if (baseService.isMobile) {
      <app-button (onChangeClick)="onCloseSidebar()" [btnType]="'icon'" matTooltip="{{ 'close' | translate }}">
        <app-icon>close</app-icon>
      </app-button>
    }
  </div>

  <mat-divider class="my-2"></mat-divider>

  @if (isLoader) {
    <div class="d-flex justify-content-center py-5">
      <app-loader size="small"></app-loader>
    </div>
  }

  @if (!isLoader) {
    <div>
      <div class="d-flex flex-column gap-3 px-4 py-2" [formGroup]="inviteForm">
        <div>
          <app-text-field
            label="{{ 'email' | translate }}"
            [formControl]="inviteForm.controls.email"
            placeholder="{{ 'enter_your_e-mail' | translate }}"
            (focusout)="this.inviteForm.controls.email.markAsTouched()"
            [error]="inviteForm.controls.email.touched && inviteForm.controls.email.invalid"
          ></app-text-field>
          @if (inviteForm.controls.email.touched && inviteForm.controls.email.invalid) {
            <mat-hint class="text-danger">
              {{ 'email_field_cannot_be_empty' | translate }}
            </mat-hint>
          }
        </div>
        <div>
          <app-dropdown
            class="w-funnels-dropdown"
            [items]="groups"
            [closeOnSelect]="true"
            [formControl]="inviteForm.controls.role"
            (focusout)="this.inviteForm.controls.role.markAsTouched()"
            label="{{ 'role' | translate }}"
            placeholder="{{ 'choose_role' | translate }}"
            [error]="inviteForm.controls.role.touched && inviteForm.controls.role.invalid"
          ></app-dropdown>
          @if (inviteForm.controls.role.touched && inviteForm.controls.role.invalid) {
            <mat-hint class="text-danger"> {{ 'field_cannot_be_empty' | translate }}. </mat-hint>
          }
        </div>
      </div>
      <div class="d-flex p-4">
        <app-button class="mt-2" [customClass]="'bg-danger'" (onChangeClick)="onCloseSidebar()">{{
          'cancel' | translate
        }}</app-button>
        <div class="flex-fill"></div>
        <app-button class="mt-2" (onChangeClick)="onSendInvite()">{{ 'invite' | translate }}</app-button>
      </div>
    </div>
  }
</div>
